<template>
  <div class="checking-the-data">
    <alert-page :emoji="'⏰'"
                :title="'נראה שאנחנו צריכים עוד קצת זמן לבניית התזרים.'">
      <template v-slot:content>
        <div class="content">
          <span class="bold">נעדכן אותך ב-WhatsApp</span> ברגע שהתזרים יהיה מוכן או אם יהיו לנו שאלות נוספות.</div>
      </template>
    </alert-page>
  </div>
</template>

<script>
import AlertPage from '../../../../../../base-components/AlertPage.vue';
import Segment from '../../../../../../Segment';

export default {
  name: 'AsyncFallback',
  components: {
    AlertPage,
  },
  created() {
    Segment.trackUserGot('AsyncFallbackEntered');
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../../../../../node_modules/base-ui/src/scss/riseup-colors';

  .checking-the-data {
    .content {
      font-size: 18px;
      line-height: 1.5em;
      white-space: pre-line;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/responsive-pages/authenticated/onboard/steps/add-credentials/AsyncFallback.vue